export default "__VITE_ASSET__uJZ9d$he__"